const websites = {
  vibe_check: {
    title: 'Vibe Check',
    support: 'We support all vibe coded urls',
    placeholder: 'https://example.lovable.app',
    validation: {
      figma_design_url:
        "Vibe check can't open Figma design files (figma.com/<tag>design</tag>) directly. Use a prototype link (figma.com/<tag>proto</tag>) or a Make link (figma.com/<tag>make</tag>) instead.",
      default:
        'This URL is not supported, please try again with a different URL.',
      modal: {
        title: 'URL not supported',
        confirm: 'Go back',
      },
    },
    faq: {
      title: "FAQ's",
      what_it_is: {
        title: 'What is Vibe check?',
        text: 'Vibe check reports on user experience for any website in the world. Submit any URL and task so an AI simulation can report on its success.',
      },
      actions: {
        title: 'Can users see why AI took the actions it did?',
        text: "Yes, every simulation presents a 'thinking' audit trail in real time. <tag>Some more about that topic here.</tag>",
      },
      report: {
        title: 'What does Vibe check report?',
        text: 'Time-on-task, miss-click prediction, path prediction, drop-off modelling, interactions.',
      },
      ai_data: {
        title: 'Will my data train AI models?',
        text: "No. Velocity has a <tag>zero retention policy</tag> with Anthropic's Claude. Velocity does not train models on any user data.",
      },
      accuracy: {
        title: 'How accurate are AI simulations?',
        text: 'Accuracy is on a case-by-case persona basis. Persona customisations are available on all paid plans. Industry-standard heuristics inform personas.',
      },
      trust: {
        title: 'How can I trust Vibe check?',
        text: 'Vibe Check currently meets the requirements for SOC 2 certification, as observed through our <tag>Trust Centre</tag>. We should obtain SOC 2 certification when our audit window closes on May 24th.',
      },
      human_testing: {
        title: 'Does this replace human testing?',
        text: 'No. AI simulation provides early quantitative validation and identifies the most significant friction points, raising overall standards before human evaluation.',
      },
      privacy: {
        title: 'Can I run Vibe Check privately?',
        text: 'Yes on Enterprise plans: <tag>contact@appvelocity.io</tag>',
      },
    },
    credentials: {
      enter: 'Enter login details (if required)',
      login: 'Username or email',
      password: 'Password',
    },
    start_simulation: 'Start simulation',
    results: {
      limit_reached: 'The simulation stopped before reaching the goal.',
      url_not_supported: 'This URL is not supported.',
      error:
        'We were unable to start your simulation. Please verify whether your link is correct and publicly accessible.',
    },
    report: {
      your_vibe: 'Your vibe',
      link: 'Report',
      unlock_benchmarking: 'Unlock competitor benchmarking',
      thinking_tab: 'Thinking',
      conversation_tab: 'Conversation ({{count}})',
      screen_reviews_tab: 'Screen reviews ({{count}})',
      appraisals_not_yet_available: 'Appraisals not yet available',
    },
    more_confidence: {
      title: 'Want more confidence in your results?',
      description:
        'Confidence is based on the number of AI simulations your website has been tested with. The more simulations you run, the more reliable your insights become.',
      run_simulation_text:
        'Run another simulation to boost your confidence score.',
      run_simulation: 'Run simulation',
      run_another_simulation: 'Run another simulation',
      preview_running_simulation: 'Preview simulation',
      select_persona_title: 'Select persona',
      select_persona_description:
        'Choose which persona should run this simulation.',
    },
    simulation_amount: {
      label: 'How many simulations?',
      option: '{{count}}',
    },
    extended_simulation: {
      sidebar_title: 'Batch simulations',
      toggle_open: 'Show batch simulations',
      toggle_close: 'Hide batch simulations',
      title: 'Extended simulations',
      description:
        'Track the batch of simulations running for this vibe check.',
      progress: '{{finished}} of {{total}} batch simulations',
      running_hint: 'Simulations are running in the background.',
      list_title: 'Simulations',
      empty_list: 'Simulations will appear here as they start.',
      simulation_n: '{{number}}',
      load_error: 'Unable to load this extended simulation.',
      review_status: {
        in_progress: 'In progress',
        completed: 'Completed',
        canceled: 'Canceled',
        restarted: 'Restarted',
        unknown: 'Unknown',
      },
      stop_all: 'Stop all',
      status: {
        waiting: 'Waiting',
        running: 'Running',
        passed: 'Passed',
        failed: 'Failed',
        completed: 'Completed',
        canceled: 'Canceled',
      },
    },
  },
  access: {
    no_access:
      "Your account doesn't have access to this resource. Try using different account.",
    level: {
      private: 'Private (only team members)',
      public: 'Public (anyone with link)',
      password_protected: 'Password protected',
    },
    password: {
      title: 'Password',
      placeholder: 'Enter the password here',
      error: {
        unable_to_validate: 'Unable to validate password.',
        incorrect: 'Incorrect password',
      },
    },
    validation: {
      password_cannot_be_empty: "Passwort can't be empty",
    },
  },
  limit_reached: {
    title: '30 steps limit reached',
    text: 'Free plans only allow 30 steps per simulation.\nNo limits are on our demos.',
    cta: 'Upgrade to run more screens',
  },
  external_navigation: {
    title: 'Navigation to other URLs disabled',
    text: 'Free plans only allow navigation inside the original domain.',
    cta: 'Upgrade to simulate freely',
  },
  rename_report: {
    title: 'Rename report',
    display_name_empty: 'Display name cannot be empty',
    new_name: 'New display name',
    new_name_placeholder: 'My new report name',
  },
  compare: {
    team_scope_hint:
      'Select a baseline Vibe Check first, then add up to 3 reports to compare against it.',
    goal_similarity: 'Prompt similarity to baseline: {{similarity}}%',
    goal_mismatch:
      'Prompt similarity to baseline is only {{similarity}}%. Metrics are still comparable, but task difficulty may differ.',
    low_sample_size:
      'Fewer than {{minimum}} completed simulations. Results may be less reliable.',
    path_preview: 'Path preview',
    no_path_preview: 'No path preview available',
    view_full_report: 'View full report',
    compare_action: 'Add to compare',
    summary: 'Summary',
    compare_with_another: 'Add to compare',
  },
} as const;

export default websites;
